import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { memo, forwardRef, useContext } from 'react';
import _Button from '../Button/index.js';
import { ModalContext } from './ModalContext.js';

var _excluded = ["modalOpenRenderButton"];
var OpenModalButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var ModalOpenRenderButton = _ref.modalOpenRenderButton,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(ModalContext),
    openButtonText = _useContext.openButtonText,
    theme = _useContext.theme,
    showModal = _useContext.showModal;
  return !!ModalOpenRenderButton ? /*#__PURE__*/React.createElement(ModalOpenRenderButton, {
    showModal: showModal,
    theme: theme
  }) : /*#__PURE__*/React.createElement(_Button, _extends({
    onClick: showModal,
    theme: theme
  }, rest), openButtonText);
});
var ModalOpenButton = /*#__PURE__*/memo(OpenModalButton);

export default ModalOpenButton;
export { OpenModalButton };
